import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IUFCount {
  total: number
  ufs: IUFCapitalCount[]
}

export interface IUFCapitalCount {
  uf: string
  estado: string
  total: number
  capital: {
    cidade: string
    total: number
  }
}

interface IUFCountState {
  ufCount: IUFCount
}

const initialState: IUFCountState = {
  ufCount: {
    total: 0,
    ufs: [],
  }
}

const UFCountSlice = createSlice({
  name: 'ufCount',
  initialState,
  reducers: {
    setUfCountState(state, action: PayloadAction<{
      ufCount: IUFCount
    }>) {
      state.ufCount = action.payload.ufCount
    }
  }
})

export const {
  setUfCountState
} = UFCountSlice.actions;
export const UFCountReducer = UFCountSlice.reducer;